




























































import { apiOrderOrderPackageInfo } from '@/api'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { navigateTo } from '@/router'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '物流详情-选择包裹',
        }))
      }

      query = useQuery<{
        // 通过订单查询
        orderNo: string
      }>()

      pageData = useApi(() =>
        apiOrderOrderPackageInfo({
          orderNo: this.query.orderNo,
        }).then(res => {
          return {
            ...res,
            items: res.items.map(item => ({
              ...item,
              show: false,
            })),
          }
        }),
      )

      handlePackageClick = (packageId: string) => {
        navigateTo('ExpressIndex', {
          orderNo: this.query.orderNo,
          packageId: packageId,
        })
      }
    },
)
